import { LOGIN, ROUTES } from '@/services/api';
import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * 获取文章管理数据列表（#253）
 */
export function getCaptchaRecordList(data) {
  return request("".concat(BASE_URL) + "/captcha/record/list", METHOD.GET, data);
}